import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { DEFAULT_TIMEOUT } from './tokens/timeout.interceptor.token';

export const timeoutInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const defaultTimeout = inject(DEFAULT_TIMEOUT);
  const timeoutValue = req.headers.get('timeout') || defaultTimeout;
  const timeoutValueNumeric = Number(timeoutValue);

  return next(req).pipe(timeout(timeoutValueNumeric));
};
